var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWithBorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 39 0.00012207)",
    stroke: "#2A86FF",
    strokeDasharray: "15 15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0303 29.0305C19.7374 29.3233 19.2626 29.3233 18.9697 29.0305L14.1967 24.2575C13.9038 23.9646 13.9038 23.4897 14.1967 23.1968C14.4896 22.9039 14.9645 22.9039 15.2574 23.1968L19.5 27.4395L23.7426 23.1968C24.0355 22.9039 24.5104 22.9039 24.8033 23.1968C25.0962 23.4897 25.0962 23.9646 24.8033 24.2575L20.0303 29.0305ZM20.25 13.5001L20.25 28.5001L18.75 28.5001L18.75 13.5001L20.25 13.5001Z",
    fill: "#2A86FF",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWithBorders);
export default __webpack_public_path__ + "static/media/arrowWithBorders.0af90f6854507792ea151af9afdcce0b.svg";
export { ForwardRef as ReactComponent };